import { render, staticRenderFns } from "./PsGroupsDialogSelectDate.vue?vue&type=template&id=5dffab29&scoped=true&"
import script from "./PsGroupsDialogSelectDate.vue?vue&type=script&lang=js&"
export * from "./PsGroupsDialogSelectDate.vue?vue&type=script&lang=js&"
import style0 from "./PsGroupsDialogSelectDate.vue?vue&type=style&index=0&id=5dffab29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffab29",
  null
  
)

export default component.exports